forms-schedules-update
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.daterange")
  script(type="typescript").
    this.mixin('forms.schedules.update')
